import Logo2 from "../../assets/navbar/logo.svg";
import React, { useState, useEffect } from "react";
import "../homepage/homepage.css";
import { useNavigate } from "react-router";
import { Eye, EyeOff } from "lucide-react";
import "./auth.css";
import ReCAPTCHA from "react-google-recaptcha";
import SubmitIcon from "../../assets/contactus/submit.svg";
import { ApiHelper } from "../../utilFunctions/utilfunction";
import { useForm } from "react-hook-form";
import { Controller } from "react-hook-form";
import countryList from "react-select-country-list";
import Select from "react-select";
import PhoneInput from "react-phone-input-2";
import { parsePhoneNumberFromString } from "libphonenumber-js";
export const Register = () => {
  const [banner, setBanner] = useState();
  const [loading, setLoading] = useState(false);
  const [flashMessage, setFlashMessage] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("gb");

  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  // For recaptcha
  const [recaptcha, setRecaptcha] = useState(true);
  const [isError, setIsError] = useState(false);
  const [isRecaptchaError, setIsRecaptchaError] = useState(false);
  // For validation

  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setConfirmPassword] = useState(false);
  const {
    register,
    watch,
    handleSubmit,
    formState: { errors },
    control,
    getValues,
  } = useForm();
  const options = countryList().getData();

  const navigate = useNavigate();
  const Submit = async (formData) => {
    if (recaptcha) {
      setIsRecaptchaError(true);
      return;
    } else {
      setIsRecaptchaError(false);
    }
    setLoading(true);

    const userTypeValue = formData.user_type === "collector" ? "1" : "2";
    const countryOption = options.find(
      (opt) => opt.value === formData.country_code
    );
    const countryName = countryOption ? countryOption.label : "";

    const reqToSend = {
      first_name: formData.first_name,
      last_name: formData.last_name,
      email: formData.email,
      phone_number: formData.phone_number,
      password: formData.password,
      password_confirmation: formData.password_confirmation,
      country_code: formData.country_code,
      country_name: countryName,
      user_type: userTypeValue,
      insta_user: formData.insta_user,
      fb_user: formData.fb_user,
    };

    try {
      const url = "/register";
      const response = await ApiHelper(url, reqToSend, "POST");
      // Navigate only on successful response
      if (response?.status === true && response?.code === 200) {
        setIsError(false);
        setMessage(
          response?.message ||
            "Registration successfull, Please check your mail."
        );
        setFlashMessage(true);
        setTimeout(() => {
          navigate("/login");
        }, 10000);
      } else {
        const errorMsg = response?.message || "registration failed.";
        console.error("Registration failed:", response);
        setIsError(true);
        setMessage(errorMsg);
        setFlashMessage(true);
      }
    } catch (error) {
      setIsError(true);
      setMessage("Something went wrong");
      setFlashMessage(true);
      setTimeout(() => {
        setFlashMessage(false);
        setMessage("");
        setIsError(false);
      }, 10000);
    } finally {
      setLoading(false);
      setTimeout(() => {
        setFlashMessage(false);
        setMessage("");

        setIsError(false);
      }, 10000);
    }

    // Reset CAPTCHA
    if (window.grecaptcha) {
      window.grecaptcha.reset();
    }
    setRecaptcha(true);
  };
  const handleChange = (value) => {
    if (value) {
      setRecaptcha(false);
      setIsRecaptchaError(false);
    } else {
      setRecaptcha(false);
    }
  };
  const accountType = watch("user_type");

  useEffect(async () => {
    let url = "/banner";
    let bannerdata = await ApiHelper(url);
    setBanner(bannerdata);
  }, []);

  return (
    <section className="mainhomepage ">
      <div className="wholepopup d-flex justify-content-center align-items-center w-100 bg-white">
        <div
          className="container d-flex flex-column back_image_color flex-md-row align-items-stretch ps-lg-0 pe-lg-0 mb-5 "
          style={{ maxHeight: flashMessage || errors ? "750px" : "450px" }}
        >
          {banner && banner.data.length ? (
            <div className="col-12 col-md-6">
              {banner.data.map((value, index) => (
                <img
                  key={index}
                  className="for_height mw-100 w-100 "
                  src={value ? value.image_path : ""}
                  alt="image"
                  style={{ objectFit: "cover", height: "100%" }}
                />
              ))}
            </div>
          ) : (
            <div className="col-12 col-md-6"></div>
          )}

          <div className="col-12 col-md-6">
            <div
              className="rightside_content d-flex justify-content-center align-items-center position-relative"
              style={{ background: "#f0f0f0" }}
            >
              <div className="d-flex flex-column flex-grow-1 align-items-center m-4">
                <img
                  style={{
                    paddingBottom: "5px",
                    maxWidth: "80%",
                  }}
                  src={Logo2}
                  alt="logo"
                />
                {/* <p
                                    className="text-center"
                                    style={{
                                        fontFamily: "Times New Roman",
                                        marginBottom: "16px",
                                        fontSize: "20px",
                                        fontWeight: "semibold",
                                    }}
                                >
                                    <strong>Join</strong> our community and explore the world of{" "}
                                    <strong>Vintage Rolex</strong> Collections.
                                </p> */}
                <h2 className="text-center fw-bold responsive-heading">
                  Create an account
                </h2>

                <form className="form" onSubmit={handleSubmit(Submit)}>
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <div className="textOnInput">
                        <input
                          className="form-control"
                          type="text"
                          style={{
                            padding: "6px 15px",
                            marginBottom: "0px !important",
                          }}
                          {...register("first_name", {
                            required: "First name is required",
                          })}
                        />
                        {errors.first_name && (
                          <p className="text-danger small">
                            {errors.first_name.message}
                          </p>
                        )}
                        <label htmlFor="first_name">First Name*</label>
                      </div>
                    </div>

                    <div className="col-12 col-md-6">
                      <div className="textOnInput">
                        <input
                          className="form-control"
                          type="text"
                          {...register("last_name", {
                            required: "Last name is required",
                          })}
                        />
                        {errors.last_name && (
                          <p className="text-danger small">
                            {errors.last_name.message}
                          </p>
                        )}
                        <label htmlFor="last_name">Last Name*</label>
                      </div>
                    </div>

                    <div className="col-12 col-md-12">
                      <div
                        className="textOnInput"
                        style={{ marginBottom: "18px" }}
                      >
                        <input
                          className="form-control"
                          type="email"
                          {...register("email", {
                            required: "Email is required",
                          })}
                        />
                        {errors.email && (
                          <p className="text-danger small">
                            {errors.email.message}
                          </p>
                        )}
                        <label htmlFor="email">Email*</label>
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="textOnInput textOnInputSelect">
                        <Controller
                          name="country_code"
                          control={control}
                          rules={{ required: "Country is required" }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={options}
                              isSearchable
                              placeholder=""
                              isClearable
                              menuPortalTarget={document.body}
                              value={
                                options.find(
                                  (opt) => opt.value === field.value
                                ) || null
                              } // ensure Select shows the correct option
                              onChange={(selectedOption) => {
                                field.onChange(
                                  selectedOption ? selectedOption.value : ""
                                );
                                if (selectedOption?.value) {
                                  const iso =
                                    selectedOption.value.toUpperCase();
                                  setSelectedCountry(iso.toLowerCase()); // phone input expects lowercase
                                }
                              }}
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  backgroundColor: "transparent",
                                  border: state.isFocused
                                    ? "1px solid black"
                                    : "1px solid #8692A6",
                                  boxShadow: state.isFocused && "none",
                                  "&:hover": {
                                    border: "1px solid black",
                                  },
                                  borderRadius: "6px",
                                  minHeight: "38px",
                                  fontSize: "16px",
                                }),
                                valueContainer: (base) => ({
                                  ...base,
                                  backgroundColor: "transparent !important",
                                  padding: "0 8px",
                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: "#000000",
                                  fontSize: "16px",
                                  fontWeight: 500,
                                  marginLeft: "6px",
                                  backgroundColor: "transparent !important",
                                }),
                                input: (base) => ({
                                  ...base,
                                  fontSize: "16px",
                                  fontWeight: 500,
                                  color: "#000000",
                                  backgroundColor: "transparent !important",
                                }),
                                menu: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                            />
                          )}
                        />
                        {errors.country_code && (
                          <p className="text-danger small">
                            {errors.country_code.message}
                          </p>
                        )}
                        <label htmlFor="country_code">Country*</label>
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="textOnInput">
                        <Controller
                          name="phone_number"
                          control={control}
                          rules={{
                            validate: (value) => {
                              if (!value || value.trim() === "") {
                                return "Phone number is required";
                              }
                              const phoneNumber =
                                parsePhoneNumberFromString(value);
                              if (!phoneNumber || !phoneNumber.isValid()) {
                                return "Invalid phone number";
                              }
                              return true;
                            },
                          }}
                          render={({ field }) => {
                            const formatted = field.value ?? "";
                            const rawForPhoneInput = formatted.replace(
                              /\D/g,
                              ""
                            );

                            return (
                              <PhoneInput
                                country={selectedCountry}
                                enableSearch
                                inputClass="form-control phone-custom-input"
                                buttonClass="phone-dropdown-btn"
                                dropdownClass="phone-dropdown-menu"
                                value={rawForPhoneInput}
                                onChange={(value, country) => {
                                  const dialDigits = country?.dialCode || "";
                                  let localDigits = value.startsWith(dialDigits)
                                    ? value.slice(dialDigits.length)
                                    : value;

                                  const maxDigits =
                                    (country?.format?.match(/\./g) || [])
                                      .length || 15;

                                  localDigits = localDigits
                                    .replace(/\D/g, "")
                                    .slice(0, maxDigits);

                                  const formattedValue = `+${dialDigits}${
                                    localDigits ? " " + localDigits : ""
                                  }`;

                                  field.onChange(formattedValue.trim());
                                }}
                              />
                            );
                          }}
                        />

                        {errors.phone_number && (
                          <p className="text-danger small ">
                            {errors.phone_number.message}
                          </p>
                        )}
                        <label htmlFor="phone">Phone Number*</label>
                      </div>
                    </div>

                    <div className="col-12 col-md-6">
                      <div className="position-relative textOnInput">
                        <input
                          className="form-control pe-5"
                          type={showPassword ? "text" : "password"}
                          {...register("password", {
                            required: "Password is required",
                          })}
                        />
                        <label htmlFor="password">Password*</label>

                        {/* Eye Icon */}
                        <span
                          onClick={() => setShowPassword(!showPassword)}
                          className="position-absolute"
                          style={{
                            top: "50%",
                            right: "10px",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            fontSize: "1.2rem",
                            color: "#aaa",
                            zIndex: 10,
                          }}
                        >
                          {showPassword ? (
                            <EyeOff size={18} />
                          ) : (
                            <Eye size={18} />
                          )}
                        </span>
                      </div>

                      {/* Error Message - placed separately so it doesn’t affect eye icon position */}
                      {errors.password && (
                        <p className="text-danger small error-text">
                          {errors.password.message}
                        </p>
                      )}
                    </div>

                    <div className="col-12 col-md-6">
                      <div className="position-relative textOnInput">
                        <input
                          className="form-control pe-5"
                          type={showConfirmPassword ? "text" : "password"}
                          {...register("password_confirmation", {
                            required: "Password Confirmation is required",
                          })}
                        />
                        <label htmlFor="password_confirmation">
                          Confirm Password*
                        </label>

                        {/* Eye Icon */}
                        <span
                          onClick={() =>
                            setConfirmPassword(!showConfirmPassword)
                          }
                          className="position-absolute"
                          style={{
                            top: "50%",
                            right: "10px",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            fontSize: "1.2rem",
                            color: "#aaa",
                          }}
                        >
                          {showConfirmPassword ? (
                            <EyeOff size={18} />
                          ) : (
                            <Eye size={18} />
                          )}
                        </span>
                      </div>

                      {/* Error Message - placed separately so it doesn’t affect eye icon position */}
                      {errors.password_confirmation && (
                        <p className="text-danger small error-text">
                          {errors.password_confirmation.message}
                        </p>
                      )}
                    </div>
                    <div className="col-12 col-md-6">
  <div className="textOnInput">
    <input
      className="form-control"
      {...register("fb_user", {
        pattern: {
          value: /^(?!.*\.\.)(?!.*\.$)(?!^\.)[a-zA-Z0-9._]{1,30}$/,
          message: "Invalid Facebook username",
        },
      })}
    />
    {errors.fb_user && (
      <p className="text-danger small">{errors.fb_user.message}</p>
    )}
    <label>Facebook Username</label>
  </div>
</div>

<div className="col-12 col-md-6">
  <div className="textOnInput">
    <input
      className="form-control"
      {...register("insta_user", {
        required: "Instagram Username is required",
        pattern: {
          value: /^(?!.*\.\.)(?!.*\.$)(?!^\.)[a-zA-Z0-9._]{1,30}$/,
          message: "Invalid Instagram username",
        },
      })}
    />
    {errors.insta_user && (
      <p className="text-danger small">{errors.insta_user.message}</p>
    )}
    <label>Instagram Username*</label>
  </div>
</div>

                    <div className="col-12 col-md-12 mb-2">
                      <div className="textOnInput textOnInputSelect mb-0">
                        <Controller
                          name="user_type"
                          control={control}
                          rules={{ required: "Account Type is required" }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={[
                                { value: "1", label: "Watch Collector" },
                                { value: "2", label: "Watch Retailer" },
                              ]}
                              isSearchable={false}
                              placeholder=""
                              isClearable
                              menuPortalTarget={document.body}
                              value={
                                field.value
                                  ? [
                                      { value: "1", label: "Watch Collector" },
                                      { value: "2", label: "Watch Retailer" },
                                    ].find(
                                      (opt) => opt.value === field.value
                                    ) || null
                                  : null
                              }
                              onChange={(selectedOption) => {
                                field.onChange(
                                  selectedOption ? selectedOption.value : ""
                                );
                              }}
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  backgroundColor: "transparent",
                                  fontSize:'12px',
                                  border: state.isFocused
                                    ? "1px solid black"
                                    : "1px solid #8692A6",
                                  boxShadow: state.isFocused && "none",
                                  "&:hover": {
                                    border: "1px solid black",
                                  },
                                  borderRadius: "6px",
                                  minHeight: "38px",
                                 
                                }),
                                valueContainer: (base) => ({
                                  ...base,
                                  backgroundColor: "transparent !important",
                                  padding: "0 8px",
                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: "#000000",
                                  fontSize: "16px",
                                  fontWeight: 500,
                                  marginLeft: "6px",
                                  backgroundColor: "transparent !important",
                                }),
                                input: (base) => ({
                                  ...base,
                                  fontSize: "16px",
                                  fontWeight: 500,
                                  color: "#000000",
                                  backgroundColor: "transparent !important",
                                }),
                                menu: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                                option: (base) => ({
                                  ...base,
                                  fontSize: "14px",
                                 
                                  cursor: "pointer",
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                            />
                          )}
                        />
                        {errors.user_type && (
                        <p className="text-danger small error-text mt-1">
                       {errors.user_type.message}
                        </p>
                      )}
                        <label htmlFor="register_as">Register as*</label>
                      </div>

                      
                    </div>
                  </div>

                  <div
                    className="col-12 col-md-6"
                    style={{
                      transform: "scale(0.75)",
                      transformOrigin: "0 0",
                      marginBottom: "-10px",
                    }}
                  >
                    <ReCAPTCHA
                      id="recaptcha"
                      sitekey={siteKey || ""}
                      onChange={handleChange}
                    />
                    {isRecaptchaError && (
                      <span
                        className="text-danger d-block"
                        style={{ fontSize: 18 }}
                      >
                        Please verify the captcha.
                      </span>
                    )}
                  </div>
                  {flashMessage && message && (
                    <div
                      className={`d-flex mt-1 align-items-center pt-2 pt-sm-0 ${
                        isError ? "text-danger" : "text-black"
                      }`}
                      style={{ marginBlock: "5px" }}
                    >
                      {!isError && (
                        <img className=" pe-2" src={SubmitIcon} alt="" />
                      )}
                      <span className="fs-5">{message}</span>
                    </div>
                  )}
                  <div className="col-12 ">
                    <button
                      type="submit"
                      className="auth-button w-100"
                      // disabled={}
                      style={{
                        fontSize: "18px",
                        fontFamily: "Times New Roman",
                        fontWeight: "bold",
                      }}
                    >
                      {loading ? (
                        <div
                          className="spinner-border text-light"
                          style={{
                            width: "1.5rem",
                            height: "1.5rem",
                            borderWidth: "0.2em",
                            marginTop: "10px",
                            borderColor: "#ccc", // All borders
                            borderTopColor: "#333", // Spinner color
                          }}
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      ) : (
                        "Sign Up"
                      )}
                    </button>

                    <div className="d-flex justify-content-center mt-2">
                      <span className="text-black">
                        Already have an account?
                      </span>
                      <a href="/login" className="ms-1 text-decoration-none">
                        Log in
                      </a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
